module.exports = __webpack_public_path__ + "static/img/logo.f126e4e1.png";